export default __webpack_public_path__ + "static/media/close.d3403cb4.svg";